import type { Component, LayoutDataItems } from '@wix/thunderbolt-becky-types'
import type { ZIndexCssChild } from './zIndexCss.types'
import { COMPONENT_TYPES, FIXED_ITEM_LAYOUT, FIXED_POSITION_ITEM_LAYOUT, MASTER_PAGE_ITEM_LAYOUT } from './constants'

const getAllCompLayouts = (zIndexChild: ZIndexCssChild): Array<LayoutDataItems> => {
	let layouts: Array<LayoutDataItems> = []
	// Adding component layouts
	if (zIndexChild.compLayouts?.default) {
		layouts = layouts.concat(zIndexChild.compLayouts?.default[''])
	}
	// Adding ref children layouts
	if (
		zIndexChild.refCompChildren?.length &&
		zIndexChild.refCompChildren[0] &&
		zIndexChild.refCompChildren[0].compLayouts?.default
	) {
		layouts = layouts.concat(zIndexChild.refCompChildren[0].compLayouts.default[''])
	}

	return layouts as Array<LayoutDataItems>
}

export const isComponentFixed = (
	zIndexChild: ZIndexCssChild,
	options: { isResponsive?: boolean } = { isResponsive: false }
): boolean => {
	if (options.isResponsive) {
		if (isRefComponent(zIndexChild?.component)) {
			// Checking if fixed item in responsive layout has FixedItemLayout -
			// It should be on all comp layouts so we are checking default only
			return getAllCompLayouts(zIndexChild).some((layoutData) => {
				return layoutData.type === FIXED_ITEM_LAYOUT
			})
		} else if (zIndexChild?.compLayouts?.default) {
			return (
				zIndexChild.compLayouts?.default[''].some((layoutData) => {
					return layoutData.type === FIXED_ITEM_LAYOUT
				}) || false
			)
		}
		return false
	}

	return zIndexChild?.component?.layout?.fixedPosition || false
}

export const isMasterPage = (component: Component): boolean => {
	return component?.componentType === COMPONENT_TYPES.MASTER_PAGE
}

export const isPageComponent = (component: Component): boolean => {
	return component?.componentType === COMPONENT_TYPES.PAGE
}

export const getCompType = (comp: Component, refCompChildren?: ZIndexCssChild['refCompChildren']): string => {
	if (
		isRefComponent(comp) &&
		refCompChildren &&
		refCompChildren.length &&
		refCompChildren[0] &&
		refCompChildren[0].component
	) {
		return refCompChildren[0].component?.componentType
	}
	return comp?.componentType
}

export const isRefComponent = (comp: Component): boolean => {
	return Boolean(comp.componentType === COMPONENT_TYPES.REF_COMPONENT && comp.components?.length)
}
